module.exports = __webpack_public_path__ + "static/media/rightArrowBlue.80d63d55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rightArrowBlue.svg
// module id = 255
// module chunks = 0